module.exports = __webpack_public_path__ + "img/wide.e600b768.jpg";